import {AuthorizeParameters} from "../models/AuthorizeParameters";
import {useLocation} from "react-router-dom";
import {parseSignInParametersFromQueryString} from "../pages/SignIn/utils";

export function useAuthorizeParameters(): AuthorizeParameters {
    const location = useLocation();
    return parseSignInParametersFromQueryString(location.search)
}
